import moment from 'moment-timezone';

export const locationBookings = (state, rootState, getters, rootGetters) => locationId => {
  return rootGetters['entities/Booking'](booking => booking.location === locationId);
};

export const locationBookingsOnDate = (state, rootState, getters, rootGetters) => ({ locationId, date }) => {
  const dateMoment = moment(date);
  const startOfDay = dateMoment.set({
    hour: 0,
    minute: 0,
    second: 0,
  }).valueOf();
  const endOfDay = dateMoment.add(1, 'day').set({
    hour: 0,
    minute: 0,
    second: 0,
  }).valueOf();

  return locationBookings(state, rootState, getters, rootGetters)(locationId).filter(booking => {
    const startTime = moment(booking.startTime).valueOf();
    return ~booking.bookingStationTimes.findIndex(bookingStationTime => {
      const endTime = moment(bookingStationTime.endTime).valueOf();
      return startTime < endOfDay && endTime > startOfDay;
    });
  });
};

export const bookingById = (state, rootState, getters, rootGetters) => bookingId => {
  return rootGetters['entities/Booking'](bookingId);
};
